import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, forwardRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, Data } from '@angular/router';
import { ErrorDO } from 'app/BaseFramework/shared/models/error.model';
import * as dict from 'spelling/dictionaries/en_US.js'
import * as spelling from 'spelling/'
import * as flat from 'flat'

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment/moment';
import { map, delay } from 'rxjs/operators';
import { of } from 'rxjs';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DynamicFormComponent),
      multi: true
    }
  ]
})
export class DynamicFormComponent implements OnInit, ControlValueAccessor {
  baseComponentName = `DynamicFormComponent`
  _currentComponentName = `DynamicFormComponent`
  @Input()
  set currentComponentName(value) {
    if (value) this._currentComponentName = value;
  }


  /**
  * 
  * ControlValueAccessor Implementation
  */
  writeValue(obj: any): void {
    if (obj === 'nullify') {
      this.FormObject.reset()
      this.propagateChange(null)
    }
  }
  propagateChange = (_: any) => { };
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void { }

  /**
    * Component Usage Example: All Inputs are Mandatory
    * <app-dynamic-form FORMNAME="submissionDataForm" FORMTITLE="Addition Fields" [IO]="payloadInEdit 
    * [currentComponentName]="'QuestionnaireComponent'" [formMetaData]='formMetaData"
    * (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"></app-dynamic-form>
    */



  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private msg: NzMessageService) { }

  //Declaraions which might need developer input
  FormObject: FormGroup
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd', 'clmMannerOfLossCd']
  selectorOfThisComponent = 'app-claims-basic-details'
  environment = environment
  parentEvent$
  currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR,
    align: this.appMetadataHandler.currencyAlignment
  }
 

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>()
  @Input() FORMNAME: string;
  @Input() FORMTITLE: string;
  @Input() headingIco: string;
  @Input() gridClass: string;
  @Input() disabled: boolean;
  @Input() formIcon: string = "profile";
  @Input() enableCollapse: boolean = false;
  @Input() showArrow: boolean = false;  
  @Input() emitInvalidComponentData: boolean = false;
  @Input() emitComponentDataInNgModel: boolean = false;
  @Input() dynamicRenderingMode:boolean = false;
  @Input() extractFromDOCoverage = false;
  //@Input() mode = this.appMetadataHandler.configDataJSON['AppConstants']['dynamicFormMetaDataConsumptionMode'] || 'sync'; // Can be made 'Async' also for sequential loading, for product configurator its set as async by default, coz it was causing error on propograteChange.
  @Input() mode = "sync";
  panelCustomStyle = {
    'background': 'transparent',
    'border': 'none',
    'border-bottom': '1px solid #dfdfdf',
    'border-radius': '0',
    'margin-bottom': '14px',
    'line-height': '1rem',
    'padding': '0 0 0px',
    'margin': 0,
  }
  @Input()
  set formMetaData(metaData) {
    if (this.commonUtilty.isArrayIterable(metaData)) {
      this.FORMMETADATAFACTORY = this.commonUtilty.sortObject('sortOrder', metaData.map(item => {
        if (!item.fieldMapping) {
          item = this.attributeMapper(item, 'fieldKey', 'fieldMapping')
        }
        return item
      }), 'asc')
      console.log("form meta data for police details", JSON.stringify(this.FORMMETADATAFACTORY));
    }
  }
  @Input() maxDepth
  private _extractElementFromArray
  @Input()
  set ExtractElementFromArray(value) {
    this._extractElementFromArray = value
  }
  get ExtractElementFromArray() {
    return this._extractElementFromArray
  }
  get flatteningSafetyValue() {
    if (this._extractElementFromArray) {
      return 'unsafe'
    }
    else {
      return 'safe'
    }
  }

  private _EnableExtractAdditionalDOs
  @Input()
  set EnableExtractAdditionalDOs(value: any) {
    if (value) {
      if (!this.ExtractElementFromArray || !this.maxDepth) {
        console.error(`Failed to set EnableExtractAdditionalDOs on ${this._currentComponentName}`)
        console.error(`Config Issue for ${this._currentComponentName}: It's mandatory to set ExtractElementFromArray and maxDepth to use EnableExtractAdditionalDOs`)
      }
      else {
        this._EnableExtractAdditionalDOs = value
      }
    }
  }

  get EnableExtractAdditionalDOs() {
    return !!this._EnableExtractAdditionalDOs
  }

  private attributeMapper(extractedConfig: any, sourceAttr, targetAttr) {
    if (extractedConfig[sourceAttr])
      extractedConfig[targetAttr] = extractedConfig[sourceAttr];
    return extractedConfig
  }

  @Input() baseDOName
  @Input() notStrictValidations
  public entityGuid  
  private flattenedIO
  private _IO
  @Input()
  set IO(value: any) {
    if (value) {
      this._IO = value
      if (!this.baseDOName) {
        this.baseDOName = this.commonUtilty.getDOName(this._IO)
      }
      if (value[this.baseDOName])
        this.entityGuid = value[this.baseDOName].guid
      else
        console.error(`Unsupported DOName for ${this.currentComponentName}`, this.baseDOName, value)
      this.flattenedIO = this.commonUtilty.flattenObject(this._IO, this.flatteningSafetyValue, this.maxDepth)
    }
  }
  get IO() {
    return this._IO
  }

  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform, this.baseComponentName)
    return c;
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return `${this._currentComponentName}`
  }

  UItoServerTransform(payload, response, DOKeyName?, handleNullIO?) {
    if (handleNullIO && !payload) {
      payload = {};
    }
    let DOName
    if (!DOKeyName)
      DOName = this.commonUtilty.getDOName(payload)
    else
      DOName = DOKeyName;
    let flattenedIO = this.commonUtilty.plainflattenObject(payload, this.flatteningSafetyValue, this.maxDepth)
    let metaData
    if (this.EnableExtractAdditionalDOs)
      metaData = this.commonUtilty.setFieldMappingForAdditionalDOs(response.componentData.metaData, payload, this.additionalAttributeValueKeyName)
    else
      metaData = response.componentData.metaData
    let form =  response.componentData.dynamicRenderingMode ? response.componentData.form :  response.componentData.form.value
    if (flattenedIO && response && DOName && payload[DOName] && metaData && Array.isArray(metaData)) {
      metaData.forEach(field => {
        let comboCondition1 = !!(field.fieldType == 'COMBO' && field.comboMode == 'multiple' && field.comboBindingType == 'CSV')
        let comboCondition2 = !!(field.fieldType == 'COMBOMULTISELECTCSV' || field.fieldType == 'COMBOMULTISELECTENTERABLECSV')

        //check if field exits on form
        if (form.hasOwnProperty(field.fieldKey)) {
          if (field.fieldType == 'DATE' && !field.ignoreDateTimeConversion) {
            flattenedIO[field.fieldMapping] = this.commonUtilty.UIDOtoServerDODate(form[field.fieldKey])
          }
          else if (field.fieldType == 'TIME' && !field.ignoreDateTimeConversion) {
            flattenedIO[field.fieldMapping] = this.commonUtilty.UIDOtoServerDOsetTime(form[field.fieldKey])
          }
          else if (comboCondition1 || comboCondition2) {
            flattenedIO[field.fieldMapping] = this.commonUtilty.convertArrayToCSV(form[field.fieldKey])
          }
          else if (field.fieldType == 'EMPTY') {
            // No Reaction on EMPTY
          }
          else {
            flattenedIO[field.fieldMapping] = form[field.fieldKey]
          }
        }
      })
    }
    else {
      console.error("Dynamic Form Error:", response)
    }

    let output = this.commonUtilty.plainUnflattenObject(flattenedIO, this.flatteningSafetyValue, this.maxDepth)

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return output
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        let validationResult = this.validateOutput(this.FormObject)
        if (!validationResult.isInvalid) {
          let output = { metaData: this.FORMMETADATAFACTORY, form: this.FormObject }
          this.EmitComponentOutput(output)
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }


  validateOutput(o): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())

    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (Form && !Form.valid) {
      for (const i in Form.controls) {
        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.FormObject.get(controlName), this.FORMNAME)
        if (Form.controls[i].status === 'INVALID') {
          if(this.commonUtilty.isArrayIterable(validationErrorList)){
            validationErrorList.forEach(validationError => {
              let errorDO = new ErrorDO();
              errorDO.errorMsg = validationError.errorMessage;
              errorDO.validationLevel = validationError.validationLevel
              errorDO.fieldName = controlName;
              errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
              errorDO.componentName = componentName;
              invalidFields.push(errorDO)
            })
          }
        }
      }
    }
    return invalidFields;
  }

  lookup$;
  lookupData = {};
  @Input() lookupLoadingMode: 'bySubject' | 'byData' = 'bySubject';

  // Front end error list
  errorList: any = [];
  metaDataValid = true
  fetchingFormData = true
  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }

    if (!this.FORMNAME || !this.FORMMETADATAFACTORY) {
      this.metaDataValid = false
    }

    this.FORMMETADATAFACTORY.forEach(metaData => {
      if (metaData.fieldGenericMapping && this.baseDOName) {
        if (!metaData.ignoreBaseDO)
          metaData.fieldMapping = metaData.fieldGenericMapping.replace(/baseDO/g, this.baseDOName)
      }
      if(typeof(metaData.columnVisibility) == 'boolean'){ //Assumption: columnVisibility will always come from lightGrid and it will not have hidden property unless we will inject from below.
        metaData.hidden = !metaData.columnVisibility;
      }
    })

    if (this.mode == 'async') {
      this.fetchMetaData().subscribe(resp => {
        this.actOnMetaData(resp);
      })
    } else {
      this.actOnMetaData(this.FORMMETADATAFACTORY);
    }

    this.subscribeToParentEvent()
  }

  private actOnMetaData(resp: any) {
    if (this.lookupLoadingMode == 'bySubject') {
      this.lookup$ = this.initializeLookupSubjects(resp);
    } else {
      this.initializeLookupData(resp);
    }
    let metaData;
    if (this.EnableExtractAdditionalDOs)
      metaData = this.commonUtilty.deepCopy(this.setFieldMappingForAdditionalDOs(resp, this.IO));

    else
      metaData = this.commonUtilty.deepCopy(resp);
    this.FormObject = this.formFactory(metaData, this.FORMNAME, this.flattenedIO);
    this.rulesExecutionMetaData = this.validateAndExecuteRules(resp);
    this.applyFieldRuleOnFields(metaData)
    this.detectChangeAndPropogateData(this.FormObject);
    this.fetchingFormData = false;
  }

  validateAndExecuteRules(metaData) {
    let output = {
      fieldsOnWatch: {},
      metaData: null
    }
    if (this.commonUtilty.isArrayIterable(metaData)) {
      metaData.forEach(field => {
        if (this.commonUtilty.isArrayIterable(field.fieldRules)) {
          field.fieldRules.forEach(fieldRule => {
            if (!output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping]) {
              let sourceFieldMetaData = metaData.find(md => md.fieldGenericMapping == fieldRule.sourceFieldGenericMapping)
              if (sourceFieldMetaData) {
                output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping] = this.commonUtilty.deepCopy(sourceFieldMetaData)
              }
              else {
                console.error(`DynamicForm Configuration Issue - sourceField:${fieldRule.sourceFieldGenericMapping} not found in metaData`, field)
              }
            }
            let evaluatedFunction = (sourceFieldKey, ruleExec, metaData) => {
              let targetAttribute = ruleExec['targetAttribute'];
              let fieldIndex = metaData.findIndex(metaDataItem => metaDataItem.fieldKey == field.fieldKey)
              if (fieldIndex != -1) {
                if (targetAttribute == 'value' && this.FormObject) {
                  this.FormObject.controls[field.fieldKey].setValue(this.operationHandler(sourceFieldKey, fieldRule.expression, metaData, this.FormObject))
                }
                else if(targetAttribute == 'hidden' && this.FormObject){

                  /*let reloadTime = 1000
                  setTimeout(() => {
                    this.FORMMETADATAFACTORY[fieldIndex][targetAttribute] = this.operationHandler(sourceFieldKey, fieldRule.expression, metaData, this.FormObject);
                  }, reloadTime);*/
                  if(!(ruleExec && ruleExec.expression && this.commonUtilty.isArrayIterable(ruleExec.expression.data) && 
                    ruleExec.expression.data.includes(this.FormObject.value[sourceFieldKey]))){
                      this.FormObject.controls[field.fieldKey].setValue(null);
                  }
                  this.FORMMETADATAFACTORY[fieldIndex][targetAttribute] = this.operationHandler(sourceFieldKey, fieldRule.expression, metaData, this.FormObject);
                }
                else{
                  this.FORMMETADATAFACTORY[fieldIndex][targetAttribute] = this.operationHandler(sourceFieldKey, fieldRule.expression, metaData, this.FormObject);
                }
              }

              return metaData
            }

            if (!output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping]) {
              output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping] = {}
            }
            if (output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping] && !this.commonUtilty.isArrayIterable(output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping]['rulesExecutionData'])) {
              output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping]['rulesExecutionData'] = []
            }

            output.fieldsOnWatch[fieldRule.sourceFieldGenericMapping]['rulesExecutionData'].push({ fieldExpressionExecultors: evaluatedFunction, ...fieldRule });
            output.metaData = this.commonUtilty.deepCopy(metaData) //Future Purpose

          });
        }
      });
    }

    return output

  }

  private applyFieldRuleOnFields(metaData: any) {
    if (this.commonUtilty.isArrayIterable(metaData)) {
      metaData.forEach(field => {
        this.fieldDataChangeHandler(field.fieldGenericMapping);
      });
    }
  }

  changeDetectionConsoleStyle = 'color: blue; background:FFF; padding: 2px 5px; border-radius: 2px'
  rulesExecutionMetaData
  executeRules(fieldGenericMapping, metaData) {
    let output = {
      rulesAffectedMetaData: []
    }

    if (this.rulesExecutionMetaData.fieldsOnWatch[fieldGenericMapping]) {
      this.processLog(`Change detected on - ${this.rulesExecutionMetaData.fieldsOnWatch[fieldGenericMapping].fieldName} `)
      let previousMetaData = this.commonUtilty.deepCopy(metaData)
      let rulesExecutionData = this.rulesExecutionMetaData.fieldsOnWatch[fieldGenericMapping]['rulesExecutionData']

      if (this.commonUtilty.isArrayIterable(rulesExecutionData)) {
        rulesExecutionData.forEach(ruleExec => {
          let evaluatedFunction = ruleExec['fieldExpressionExecultors'].bind(this)
          let sourceMetaDataMap = this.commonUtilty.convertArrayToMap(metaData, 'fieldGenericMapping')
          metaData = evaluatedFunction(sourceMetaDataMap[fieldGenericMapping]['fieldKey'], ruleExec, metaData)

          if (JSON.stringify(previousMetaData) === JSON.stringify(metaData)) {
            this.processLog(`Change in ${fieldGenericMapping} has affected other fields`)
          }
        });
      }


    }

    return metaData
  }

  operationHandler(sourceFieldKey, expression, metaData, FORM) {
    let output = null
    if (expression && this.commonUtilty.isArrayIterable(metaData)) {
      //valueOf is going to be fieldGenericMapping
      if (expression.expectedValueOf && FORM) {
        let metaData_expectedValueOf = metaData.find(md => md.fieldGenericMapping == expression.expectedValueOf)
        let expectedValueOf = FORM.get(metaData_expectedValueOf.fieldKey).value
        if (!expression.data && Array.isArray(expression.data) && expectedValueOf) {
          expression.data = []
        }
        expression.data.push(expectedValueOf)
      }
      let sourceFieldData = FORM ? FORM.value[sourceFieldKey] : null;

      switch (expression.operation) {
        // EQUAL
        case '==':
          output = Array.isArray(expression.data) ?  expression.data.includes(sourceFieldData) :  expression.data == expression.data
          break;

        // NOTEQUAL
        case '!=':
          output = Array.isArray(expression.data) ?  !expression.data.includes(sourceFieldData) : expression.data != expression.data
          break;

        // LESSTHAN
        case '>':
          output = Array.isArray(expression.data) ? expression.data.every(d => sourceFieldData > d) : expression.data > expression.data
          break;

        // GREATERTHAN
        case '<':
          output = Array.isArray(expression.data) ? expression.data.every(d => sourceFieldData < d) :  expression.data < expression.data
          break;

        case 'DATEDIFF': {
          if (FORM && FORM.get(expression.DATE1).value && FORM.get(expression.DATE2).value) {
            let value = Math.abs(moment(FORM.get(expression.DATE1).value).diff(FORM.get(expression.DATE2).value, 'days'))
            output = isNaN(value) ? 0 : value
          }
          break;
        }
        case 'T2S': {
          if (sourceFieldData) {
            let value = this.multiLingualService.ConvertChineseT2S(sourceFieldData)
            output = value
          }
          break;
        }
        case 'S2T': {
          if (sourceFieldData) {
            let value = this.multiLingualService.ConvertChineseS2T(sourceFieldData)
            output = value
          }
          break;
        }

        default:
          this.processLog("Invalid Operation Metadata", 'error')
          break;
      }

    }
    else {
      console.error("Operation Handler: Invalid Expression or Invalid Metadata", expression, metaData)
    }

    return output
  }

  fieldDataChangeHandler(fieldGenericMapping) {
    if (this.rulesExecutionMetaData && this.rulesExecutionMetaData.fieldsOnWatch[fieldGenericMapping]) {
      this.FORMMETADATAFACTORY = this.executeRules(fieldGenericMapping, this.FORMMETADATAFACTORY)
      // this.FORMMETADATAFACTORY = this.commonUtilty.deepCopy(changedMetaData)
      this.lookup$ = this.initializeLookupSubjects(this.FORMMETADATAFACTORY);
    }
  }

  /**
   * 
   *  <ng-template #indicatorTemplate><i nz-icon nzType="loading" style="font-size: 24px;"></i> </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
   * 
   */

  processLog(msg, type?, Object?) {
    let logType = type || 'log'
    let msgType = type || 'info'
    let style = !type ? this.changeDetectionConsoleStyle : null

    if (!environment.production)
      this.msg[msgType](msg)
    if (Object)
      console[logType](`%c Process Log: ${msg}`, style, Object)
    else
      console[logType](`%c Process Log: ${msg}`, style)
  }


  /**
   * Form Trasactions
   */

  FormFieldNameMap = {
    eventType: "Event Type",
    eventDate: "Event Date",
    retypeEventDate: "Retype Event Date",
    eventTime: "Event Time",
    retypeEventTime: "Retype Time",
    causeOfDeath: "Cause of Death",
    intimationDt: "Intimation Date",
    receivedDt: "Received Date",
  }

  fetchMetaData() {
    return of(this.FORMMETADATAFACTORY).pipe(delay(100))
  }

  expressionEval(expression) {
    const result = (() => {
      return eval(expression.value);
    })();
    return result
  }

  FORMMETADATAFACTORY: any = [];
  FORMMETADATAFACTORY_old: any = [
    {
      fieldName: "Event Type",
      fieldKey: "eventType",
      fieldType: 'COMBO',
      disabled: false,
      currencyPipe: false,
      defaultValue: null,
      lookupCd: 'clmEventTypeCd',
      fieldGenericMapping: "baseDO-eventTypeCd",
      fieldMapping: "claimDO-eventTypeCd"
    },
    {
      fieldName: "Intimation Date",
      fieldKey: "intimationDt",
      fieldType: 'DATE',
      visibilityExpression: "form-eventType == 'ACCIDENT'",
      disabled: false,
      defaultValue: null,
      lookupCd: null,
      lineBreakAfterThisField: true,
      fieldGenericMapping: "baseDO-intimationDt",
      fieldMapping: "claimDO-intimationDt"
    },
    {
      fieldName: "FIR Copy Upload",
      fieldKey: null,
      fieldType: 'DOCUMENT',
      docConfig: {
        requirementCd: "FIRCOPY",
        clientRefGuid: null,
        headingType: "label"
      },
      lookupCd: null,
      fieldGenericMapping: "baseDO-intimationDt",
      fieldMapping: "claimDO-intimationDt"
    },
    {
      fieldName: "Remarks",
      fieldKey: null,
      fieldType: 'TEXTAREA',
      maxlength: 2000,
      lookupCd: null,
      fieldGenericMapping: "baseDO-intimationDt",
      fieldMapping: "claimDO-intimationDt",
      fieldRules: [
        {
          "sourceFieldGenericMapping": "baseDO-preAuthType",
          "sourceField": "preAuthType",
          "targetAttribute": "hidden",
          "expression": {
            "operation": "!=",
            "expectedValueOf": null,
            "data": [
              "ACCIDENT",
              "AACIDENT"
            ]
          },
          "result": null
        }
      ]
    }
  ]

  private initializeLookupSubjects(metaData) {
    if (metaData && Array.isArray(metaData))
      metaData.forEach(field => { this.lookupsToBind.push(field.lookupCd); });
    let lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind, metaData);
    return lookup$
  }

  private initializeLookupData(metaData) {
    if (metaData && Array.isArray(metaData))
      metaData.forEach(field => { this.lookupsToBind.push(field.lookupCd); });
    this.initializeLookupListWithData(this.lookupsToBind, metaData);
    //return lookup;
  }

  initializeLookupListWithData(lookupList, metaData?) {
    //var returnItem = {}
    //let lookupListDataSubject = new Subject();
    if (lookupList && lookupList.length > 0) {
        lookupList.forEach(lookup => {
            if(lookup){
                let filteredMetaData= metaData ? metaData.filter(item => item.lookupCd == lookup) : null;
                let filteredLookupCSV = this.commonUtilty.isArrayIterable(filteredMetaData) ? filteredMetaData.find(e => true).allowedLookUpCdCSV ? filteredMetaData.find(e => true).allowedLookUpCdCSV.split(',') : null : null;
                this.lookupDataService.getLookup(lookup,false).subscribe(item => {
                  this.lookupData[lookup] = this.filterLookupData(item, filteredLookupCSV);
                });
            }
        })
        // zip(this.convertMapToArray(returnItem)).subscribe(resp => { 
        //     lookupListDataSubject.next(this.convertArrayToMap(resp, 'lookupCd')) 
        // });
    }
    //return lookupListDataSubject;
}

filterLookupData(lookupList, criteriaFilteredLookup?) {
  let output = [];
  if (criteriaFilteredLookup) {
      for (var i = 0; i < lookupList.length; i++) {
          if (criteriaFilteredLookup.indexOf(lookupList[i].lookupKey) !== -1) {
              output.push(lookupList[i]);
          }
      }
  } else {
      output = JSON.parse(JSON.stringify(lookupList));
  }
  return output;
}

  private _additionalAttributeValueKeyName
  @Input()
  set additionalAttributeValueKeyName(value) {
    this.additionalAttributeValueKeyName = value || 'attributeValue'
  }
  get additionalAttributeValueKeyName() {
    return this._additionalAttributeValueKeyName
  }

  formFactory(metaData, FormName, IO = {}) {
    let formDataOuput = {}
    if (metaData && Array.isArray(metaData)) {
      metaData.forEach((field, index) => {
        let intialValue
        // let codifiedExpression = field.visibilityExpression.replace(/form-/g, "this.FormObject.value.")
        // field.expressionResult = this.expressionEval(codifiedExpression)
        let dictspell = new spelling(dict)
        let output = this.splitMulti(field.fieldName, ['/', ' ', '-', '(', ')'])
        let wrongWords = [];
        let spellResultWrong
        let didYouMean = []
        if (Array.isArray(output)) {
          output.forEach(word => {
            if (!dictspell.lookup(word)['found']) {
              wrongWords.push(word)
              let suggestions = dictspell.lookup(word)['suggestions']
              if (this.commonUtilty.isArrayIterable(suggestions)) {
                didYouMean = suggestions.map(a => a.word);
              }
            }
          })
        }
        // { found: true, word: 'he', rank: 38410 }
        let comboCondition1 = !!(field.fieldType == 'COMBO' && field.comboMode == 'multiple' && field.comboBindingType == 'CSV')
        let comboCondition2 = !!(field.fieldType == 'COMBOMULTISELECTCSV' || field.fieldType == 'COMBOMULTISELECTENTERABLECSV')
        
        this.FORMMETADATAFACTORY[index].fieldNameSpellCheckCorrent = !this.commonUtilty.isArrayIterable(wrongWords)
        this.FORMMETADATAFACTORY[index].wrongSpellWords = `Wrong Ones - ${wrongWords.join(', ')}. Did you mean? - ${didYouMean.join(', ')}`;

        if(this.extractFromDOCoverage){intialValue = this.formExtractFromDO(IO , field)}
        else{
          if (field.fieldType == 'DATE') {
            let data = IO[field.fieldMapping] || (field.defaultValue == "NOW" ? this.commonUtilty.UIDOtoServerDODate(new Date()) : field.defaultValue)
            if(this.commonUtilty.isArrayIterable(data))
            intialValue = this.commonUtilty.serverDOtoUIDOsetTime(data)
            else if(data && data.includes(":"))
            {
              let array= data.split(":").map( item =>{
                return Number(item);
              })

              intialValue = this.commonUtilty.serverDOtoUIDOsetTime(array)
            }
          }
          else if (field.fieldType == 'TIME') {
            let data = IO[field.fieldMapping] || field.defaultValue
            intialValue = this.commonUtilty.serverDOtoUIDOsetTime(data)
          }
          else if (field.fieldType == 'EMPTY') {
            //No Reaction of EMPTY
          }
          else if (comboCondition1 || comboCondition2) {
            let data = IO[field.fieldMapping] || field.defaultValue
            intialValue = this.commonUtilty.convertCSVToArray(data)
          }
          else{
            intialValue = IO[field.fieldMapping] || field.defaultValue
          }
        }
        //For Extracting one Array Item from IO
        // if(field.extractElementFromArray){
        //   intialValue = intialValue ? intialValue[field.extractElementNumber] : intialValue
        // }
        this.FormFieldNameMap[field.fieldKey] = field.fieldName;
        formDataOuput[field.fieldKey] = this.validationUtilService.setValidationsForFormControl(
          field.fieldKey, FormName, intialValue, null, field.validationList)

        //this.fieldDataChangeHandler(field.fieldGenericMapping)
      })
    }

    let output = this.fb.group(formDataOuput)

    return output
  }

  formExtractFromDO(IO, field){
    let comboCondition3 = (field.fieldType == 'COMBO' || field.fieldType == 'CURRENCYINPUT')
    let index = this.getIndex(field.fieldMapping)
    let intialValue = null;
    if (comboCondition3 && IO && IO["proposalDO-proposalCoverages"] 
       && IO["proposalDO-proposalCoverages"][index] &&
        (IO["proposalDO-proposalCoverages"][index][field.fieldKey] || !IO["proposalDO-proposalCoverages"][index][field.fieldKey])) {
      intialValue = IO["proposalDO-proposalCoverages"][index][field.fieldKey];
    }
    else if(comboCondition3 && IO && IO["caseDO-caseCoverages"] 
       && IO["caseDO-caseCoverages"][index] &&
        (IO["caseDO-caseCoverages"][index][field.fieldKey] || !IO["caseDO-caseCoverages"][index][field.fieldKey])) {
      intialValue = IO["caseDO-caseCoverages"][index][field.fieldKey];
    }
    return intialValue;
}


  getIndex(mapping){
    const str = mapping;
    const match = str.match(/\d+/);
    let extractedNumber: number | undefined;
    if (match) {
      extractedNumber = parseInt(match[0]);
    }
    return extractedNumber;
  }

  private setFieldMappingForAdditionalDOs(metaData: any, nestedIO: any) {

    if (metaData && Array.isArray(metaData)) {
      metaData.forEach((field, index) => {
        if (field.fieldMapping && field.fieldMapping.includes('$additionalDetails')) {
          let attributes = this.splitMulti(field.fieldMapping, ['-']) || [];
          let attributeCd = field.fieldKey;
          let attributeKeyName = attributes.slice(-2);

          let newBaseMapping = this.commonUtilty.truncateAfter(field.fieldMapping, '$additionalDetails').replace('$', '0-');
          let newMapping;
          if (newBaseMapping && nestedIO && nestedIO[newBaseMapping] && Array.isArray(nestedIO[newBaseMapping])) {
            let foundIndex = nestedIO[newBaseMapping].findIndex(element => element[attributeKeyName] == attributeCd);
            if (foundIndex != -1) {
              newMapping = `${newBaseMapping}-${foundIndex}-${this.additionalAttributeValueKeyName}`;
            }
            else {
              let newIndex = nestedIO[newBaseMapping].length;
              newMapping = `${newBaseMapping}-${newIndex}-${this.additionalAttributeValueKeyName}`;
            }
          }

          if (newMapping) {
            metaData[index]['oldFieldMapping'] = field.fieldMapping;
            field.fieldMapping = newMapping;
            metaData[index]['fieldMapping'] = newMapping;
            metaData[index]['attributeKeyName'] = attributeKeyName
            metaData[index]['isAdditionalDO'] = true
            metaData[index]['additionalAttributeValueKeyName'] = this.additionalAttributeValueKeyName

          }

        }
      })
    }

    return metaData
  }

  detectChangeAndPropogateData(form: FormGroup) {
    if (form) {
      
      let output = { metaData: this.FORMMETADATAFACTORY, form: form.value, dynamicRenderingMode: this.dynamicRenderingMode, errorDOs:[] }
      this.propagateChange(this.emitComponentDataInNgModel ? this.EmitComponentOutput(output) : form.value )
      form.valueChanges.subscribe(e => {
        let validationResult = this.validateOutput(this.FormObject)
        if (!validationResult.isInvalid) {
          output = { metaData: this.FORMMETADATAFACTORY, form: form.value, dynamicRenderingMode: this.dynamicRenderingMode,errorDOs:validationResult.errorDOs}
          this.propagateChange(this.emitComponentDataInNgModel ? this.EmitComponentOutput(output) : form.value )
        }else{
          output = { metaData: this.FORMMETADATAFACTORY, form: form.value, dynamicRenderingMode: this.dynamicRenderingMode,errorDOs:validationResult.errorDOs}
          this.propagateChange(this.emitComponentDataInNgModel ? this.EmitComponentOutput(output) : form.value )
        }
      })
    }
    else {
      console.error(`${this._currentComponentName} - Form Object is missing`)
    }
  }

  // @Input() outputMode: any;
  // detectChangeAndPropogateData(form: FormGroup) {
  //   if (form) {
  //     let validationResult = this.validateOutput(form);
  //     let componentFirstOutput = this.EmitComponentOutput({ metaData: this.FORMMETADATAFACTORY, form: this.FormObject })
  //     let firstOutput = this.UItoServerTransform(this.IO, componentFirstOutput, this.baseDOName, true)
  //     if (this.outputMode && this.outputMode == 'ComponentOutput') {
  //       this.getDataToPropagate(componentFirstOutput, validationResult)
  //       // this.commonUtilty.isArrayIterable(validationResult.errorDOs) && !!!this.notStrictValidations ? this.getDataToPropagate(componentFirstOutput, validationResult) : this.propagateChange(componentFirstOutput)
  //     } else
  //       this.getDataToPropagate(firstOutput, validationResult)
  //     // this.commonUtilty.isArrayIterable(validationResult.errorDOs) && !!!this.notStrictValidations ? this.getDataToPropagate(firstOutput, validationResult) : this.propagateChange(firstOutput)
  //     form.valueChanges.subscribe(e => {
  //       let currentValidationResult = this.validateOutput(form);
  //       let componentOuput = this.EmitComponentOutput({ metaData: this.FORMMETADATAFACTORY, form: this.FormObject })
  //       let output = this.UItoServerTransform(this.IO, componentOuput, this.baseDOName, true)
  //       if (this.outputMode && this.outputMode == 'ComponentOutput') {
  //         this.getDataToPropagate(componentOuput, currentValidationResult)
  //         // this.commonUtilty.isArrayIterable(currentValidationResult.errorDOs) && !!!this.notStrictValidations ? this.propagateChange(Object.assign({}, componentOuput, currentValidationResult)) : this.propagateChange(componentOuput)
  //       } else {
  //         this.getDataToPropagate(output, currentValidationResult)
  //         // this.commonUtilty.isArrayIterable(currentValidationResult.errorDOs) && !!!this.notStrictValidations ? this.propagateChange(Object.assign({}, output, currentValidationResult)) : this.propagateChange(output)
  //       }
  //     })
  //   }
  //   else {
  //     console.error(`${this._currentComponentName} - Form Object is missing`)
  //   }
  // }

  // private getDataToPropagate(componentData: ComponentOutputDO, validationResult: ValidationOutput) {
  //   if (this.emitInvalidComponentData)
  //     return this.propagateChange(Object.assign({}, componentData, validationResult));
  //   else {
  //     if (this.commonUtilty.isArrayIterable(validationResult) && !!!this.notStrictValidations)
  //       this.propagateChange(validationResult)
  //     else this.propagateChange(componentData)
  //   }
  // }

  isRequired(fieldName, formName?, searchAllValidations?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.FORMNAME
    }
    if (searchAllValidations)
      return this.validationUtilService.isRequired(fieldName, nameOfForm)
    else if (this.FormObject.get(fieldName) && this.FormObject.get(fieldName).validator) {
      let requiredValidator = this.FormObject.get(fieldName).validator({} as AbstractControl);
      return (requiredValidator && requiredValidator.required)
    }
  }

  getalidator(fieldKey) {
    const validator = this.FormObject.get('control').validator({} as AbstractControl);
    console.log(validator);
    if (validator && validator.required) {
      return true;
    }
  }

  splitMulti(str, tokens) {
    var tempChar = tokens[0]; // We can use the first token as a temporary join character
    if (str) {
      for (var i = 1; i < tokens.length; i++) {
        str = str.split(tokens[i]).join(tempChar);
      }
      str = str.split(tempChar);
    }
    return str;
  }



}